<header class="site-header">
  <nav class="navbar navbar-expand-lg main-navbar">
    <div class="container-fluid px-3 px-lg-4">
      <a class="navbar-brand d-flex align-items-center gap-2" routerLink="/">
        <img src="assets/images/logo.png" alt="UMYO Gossip" class="brand-logo" onerror="this.style.display='none'">
        <span class="brand-text">
          UMYO <span class="text-pink">GOSSIP</span>
          <small class="d-block">DIRECTORY</small>
        </span>
      </a>

      <button class="menu-btn d-flex d-md-none navbar-toggler"
        type="button"
        (click)="isNavOpen = !isNavOpen"
        [attr.aria-expanded]="isNavOpen"
        aria-controls="navbarNav"
        aria-label="Toggle navigation"
      >
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 6h18M3 12h18M3 18h18"/>
        </svg>
      </button>

      <div class="navbar-collapse justify-content-center" id="navbarNav" [class.show]="isNavOpen">
        <ul class="navbar-nav main-nav">
          <li class="nav-item"><a class="nav-link " routerLink="/" (click)="isNavOpen = false">Home</a></li>
          <li class="nav-item"><a class="nav-link " routerLink="/directory" (click)="isNavOpen = false">Directory</a></li>
          <li class="nav-item"><a class="nav-link " routerLink="/packages" (click)="isNavOpen = false">Packages</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/platforms" (click)="isNavOpen = false">Platforms</a></li>
          <li class="nav-item">
            <a class="nav-link" href="/assets/creat-card/index.html" target="_self">Creat Your Card</a>
          </li>
          <li class="nav-item"><a class="nav-link" routerLink="/hardship" (click)="isNavOpen = false">Harships Incentives</a></li>
        </ul>
      </div>
      <div class="d-none d-md-flex align-items-center gap-2">
        <a href="/?authTab=login#login" class="btn btn-outline-pink btn-sm-pad">LOGIN</a>
        <a href="/?authTab=register#register" class="btn btn-pink">
          REGISTER NOW
        </a>
      </div>
    </div>
  </nav>
</header>

<!-- ============ HERO ============ -->
<section class="tc-hero">
  <div class="container" style="position:relative;z-index:1;">
    <span class="hs-eyebrow">LEGAL &amp; PLATFORM POLICIES</span>
    <h1 class="tc-hero-title">
      TERMS &amp;<br>
      <span class="text-pink">CONDITIONS.</span>
    </h1>
    <p class="tc-hero-subtitle">
      Please read these terms carefully before participating in any UMYO
      Gossip ecosystem. By joining, you agree to the following policies
      governing expression, conduct, and platform participation.
    </p>
  </div>
</section>

<!-- ============ TERMS CONTENT ============ -->
<main class="tc-body">
  <div class="container">
    <div class="tc-wrap">

      <span class="tc-meta">LAST UPDATED · UMYO GOSSIP PLATFORM POLICIES</span>

      <!-- SECTION 1 -->
      <div class="tc-card">
        <div class="tc-num">01</div>
        <h2 class="tc-title">Expression and Ecosystem Scope</h2>
        <p>The Platform operates as a collection of <strong>mission-specific digital ecosystems</strong>. Each ecosystem functions as a purpose-driven private online association with a defined scope of discussion.</p>
        <p>Members are encouraged to engage in open expression within the stated mission and intended purpose of the ecosystem they have joined. Expression is permitted to the extent it aligns with the ecosystem's defined focus and participation standards.</p>
        <p>Content, discussions, or activities that fall outside the stated mission or scope of a particular ecosystem may be moderated, restricted, redirected, or removed at the Company's discretion.</p>
        <p>The Company does not regulate expression based on viewpoint alone. Moderation decisions are based on alignment with ecosystem purpose, adherence to participation standards, and compliance with Platform-wide policies.</p>
        <p>Participation in any ecosystem is conditional and subject to continued compliance with applicable guidelines. Access to an ecosystem is a <strong>revocable license</strong> and may be suspended or terminated for violations of its stated mission, conduct standards, or Platform policies.</p>
        <p>Membership in one ecosystem does not grant rights, privileges, or expression authority within any other ecosystem.</p>
        <div class="tc-highlight">
          UMYO operates multiple mission-specific private digital ecosystems. Participation is voluntary and conditioned upon agreement to the mission and standards of each ecosystem. The platform does not guarantee unrestricted expression.
        </div>
        <ul class="tc-list">
          <li>Content may be moderated or removed if deemed outside the mission scope of the selected ecosystem, regardless of viewpoint.</li>
          <li>Mission-aligned expression: Speech is free within the mission of the ecosystem — not free across all topics everywhere.</li>
        </ul>
      </div>

      <!-- SECTION 2 -->
      <div class="tc-card">
        <div class="tc-num">02</div>
        <h2 class="tc-title">Non-Discrimination and Mission Alignment</h2>
        <p>The Company provides access to the Platform <strong>without discrimination</strong> based on race, color, religion, sex, gender identity, sexual orientation, national origin, disability, political affiliation, or other legally protected characteristics.</p>
        <p>Access to individual ecosystems is conditioned upon agreement to and compliance with that ecosystem's stated mission, scope, and participation standards. Moderation decisions are based on:</p>
        <ul class="tc-list">
          <li>Conduct and behavior within the ecosystem</li>
          <li>Mission alignment with the stated ecosystem purpose</li>
          <li>Adherence to Platform-wide policies</li>
          <li>Not on a member's personal identity or protected characteristics</li>
        </ul>
        <p>The Company reserves the right to suspend or terminate participation in any ecosystem where a member's conduct is inconsistent with its stated purpose or applicable guidelines.</p>
      </div>

      <!-- SECTION 3 -->
      <div class="tc-card">
        <div class="tc-num">03</div>
        <h2 class="tc-title">Member Appeals and Review Process</h2>
        <p>Members who believe a moderation action was taken in error may submit a written appeal within <strong>fourteen (14) days</strong> of the action.</p>
        <p>Appeals must include sufficient detail to allow review of the decision, including:</p>
        <ul class="tc-list">
          <li>The relevant ecosystem name</li>
          <li>Date of the moderation action</li>
          <li>A description of the basis for the appeal</li>
        </ul>
        <p>Upon receipt of a valid appeal request, the Company will conduct an internal review of the moderation decision. Review may include evaluation of the original content, applicable ecosystem guidelines, and compliance with Platform policies.</p>
        <div class="tc-highlight">
          The Company may uphold, modify, or reverse the original decision at its discretion. Decisions issued upon appeal are final.
        </div>
        <p>Submission of an appeal does not guarantee reinstatement, refund, or restoration of access. During the review period, access may remain suspended.</p>
        <p>The Company reserves the right to decline repetitive, abusive, or bad-faith appeals.</p>
      </div>

    </div>
  </div>
</main>

<!-- ============ FOOTER ============ -->
<footer class="site-footer pkg-footer">
  <div class="container-fluid px-3 px-lg-4">
    <div class="row py-5">

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <div class="d-flex align-items-center gap-2 mb-2">
          <img src="assets/images/logo.png" alt="UMYO Gossip" class="brand-logo" onerror="this.style.display='none'">
          <div class="brand-text">UMYO <span class="text-pink">GOSSIP</span></div>
        </div>
        <small class="d-block pkg-footer-muted">YOUR VOICE. YOUR COMMUNITY.<br>POWERED BY UMYO.</small>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">QUICK LINKS</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/">Home</a></li>
          <li><a routerLink="/directory">Directory</a></li>
          <li><a routerLink="/packages">Packages</a></li>
          <li><a routerLink="/platforms">Platforms</a></li>
          <li><a routerLink="/hardship">Incentives</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">RESOURCES</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/services">Services</a></li>
          <li><a routerLink="/how-to">How To</a></li>
          <li><a routerLink="/hardship">Hardship Incentives</a></li>
          <li><a href="/privacy">Privacy Policy</a></li>
          <li><a href="/terms">Terms of Service</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6">
        <h6 class="pkg-footer-heading">LET'S CONNECT</h6>
        <div class="social-icons justify-content-start">
          <a href="#" aria-label="Instagram">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="TikTok">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 3v11.5a3.5 3.5 0 1 1-3-3.46"/><path d="M14 3c.4 2.6 2.2 4.4 5 4.8"/>
            </svg>
          </a>
          <a href="#" aria-label="YouTube">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="5" width="20" height="14" rx="4"/><path d="M10 9l6 3-6 3V9Z" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="Facebook">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3Z"/>
            </svg>
          </a>
          <a href="#" aria-label="X">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4l16 16M20 4 4 20"/>
            </svg>
          </a>
        </div>
      </div>

    </div>

    <div class="pkg-footer-bottom text-center py-3">
      <small>© 2026 UMYO Gossip Directory. All Rights Reserved.</small>
    </div>
  </div>
</footer>
